import { Box, Popover, Portal, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { useState } from 'react';
import { Category, CategoryPreview, RootCategory, Subcategory } from 'src/api/v1-api';
import { FilterPopoverButton, FilterPopoverContent } from 'src/components/atoms';
import { useAttributeSelector } from 'src/contexts/AttributeSelector';

interface CategoryFilterProps {
  isMobileView?: boolean;
  category?: Category | RootCategory | CategoryPreview;
  onCategoryChange?: (category: Subcategory) => void;
  onCancel?: () => void;
}

const CategoryFilter = ({
  category,
  isMobileView,
  onCategoryChange,
  onCancel,
}: CategoryFilterProps) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>('');
  const { commitStagedAttributes } = useAttributeSelector();

  const handleCancel = () => {
    setSelectedCategoryId('');
    onCancel?.();
  };

  const subCategories = (category?.children ?? []).filter(
    (subcategory) => subcategory.position >= 0 && subcategory.image && !subcategory.cta_link,
  );

  return isMobileView ? (
    <Box maxHeight="320px" overflowY="auto" overflowX="hidden">
      <Stack as="fieldset" spacing={2}>
        <RadioGroup
          onChange={(value) => {
            const selectedSubCategory = subCategories.find(
              (subCat) => subCat.id.toString() === value,
            );
            if (selectedSubCategory && onCategoryChange) {
              setSelectedCategoryId(value);
              onCategoryChange(selectedSubCategory);
            }
          }}
          defaultValue=""
          value={selectedCategoryId}
        >
          <Stack spacing={2}>
            {subCategories.map((subCategory: Subcategory) => (
              <Radio key={subCategory.id} value={subCategory.id.toString()}>
                {subCategory.name}
              </Radio>
            ))}
          </Stack>
        </RadioGroup>
      </Stack>
    </Box>
  ) : (
    <Popover placement="bottom-start">
      <FilterPopoverButton label={'Category'} />
      <Portal>
        <FilterPopoverContent onClickApply={commitStagedAttributes} onClickCancel={handleCancel}>
          <Box maxHeight="320px" overflowY="auto" overflowX="hidden">
            <Stack as="fieldset" spacing={2}>
              <RadioGroup
                onChange={(value) => {
                  const selectedSubCategory = subCategories.find(
                    (subCat) => subCat.id.toString() === value,
                  );
                  if (selectedSubCategory && onCategoryChange) {
                    setSelectedCategoryId(value);
                    onCategoryChange(selectedSubCategory);
                  }
                }}
                defaultValue=""
                value={selectedCategoryId}
              >
                <Stack spacing={2}>
                  {subCategories.map((subCategory: Subcategory) => (
                    <Radio key={subCategory.id} value={subCategory.id.toString()}>
                      {subCategory.name}
                    </Radio>
                  ))}
                </Stack>
              </RadioGroup>
            </Stack>
          </Box>
        </FilterPopoverContent>
      </Portal>
    </Popover>
  );
};

export default CategoryFilter;
